export default "__VITE_ASSET__DvKxvvW5__"